export default {
  name: 'Upstairs Bathroom',
  id: 'UpstairsBathroom',
  data: [
    // {
    //   title: 'The showerhead has accumulated blue-green lime scale deposits.',
    //   icon1: '/static/svgs/second-floor-bathroom/shower-head-mold.svg',
    //   answers: [
    //     'Pour club soda on the showerhead to dissolve the lime scale.',
    //   ],
    //   correctAnswerIndex: 2,
    //   position: {
    //     x: 0.4,
    //     y: 6,
    //     z: 1.6
    //   },
    //   completed: false
    // },
    // {
    //   title: 'Mold has collected behind the sink.',
    //   icon1: '/static/svgs/second-floor-bathroom/sink-with-mold.svg',
    //   answers: [
    //     'Spray bleach on the mold and scrub with a sponge until it is visibly gone.',
    //   ],
    //   correctAnswerIndex: 1,
    //   position: {
    //     x: 0.9,
    //     y: 5,
    //     z: 0.7
    //   },
    //   completed: false
    // },
    {
      title: 'A puddle forms by the shower each time it is used.',
      icon1: '/static/svgs/second-floor-bathroom/bathroom-2.svg',
      answers: [
        'If you hear thunder, hold off on showering until the storm passes. Lightning can travel through metal pipes and shock on contact.',
      ],
      correctAnswerIndex: 0,
      position: {
        x: 0,
        y: 5,
        z: 1
      },
      completed: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/residential/secondFloor/Bathroom.js